import { Link } from "react-router-dom"
import AdminNav from "./AdminNav"
import UserMenu from "./UserMenu"

const AdminLayout = ({ children, headerActions }) => {
  return (
    <div className="bg-background flex flex-col h-screen">
      {/* Header */}
      <div className="bg-white px-8 py-4 border-b">
        <div className="flex items-center justify-between">
          <Link to="/plan">
            <img src="/logo.png" alt="Encircled Logo" className="w-36 cursor-pointer" />
          </Link>
          <div className="flex items-center gap-4">
            {headerActions}
            <UserMenu />
          </div>
        </div>
      </div>

      {/* Navigation */}
      <AdminNav />

      <div className="flex-1 overflow-auto">
        {/* Content */}
        {children}
      </div>
    </div>
  )
}

export default AdminLayout
